import React from 'react'
import PropTypes from 'prop-types'
import styles from './LoadingDots.module.scss'

const LoadingDots = props => {
    return (
        <div className={styles.loadingHolder} role="status" aria-live="polite">
            <div className={styles.loadingHolder_wrapper}>
                <div className={styles.loadingHolder_wrapper_ball}></div>
                <div className={styles.loadingHolder_wrapper_ball}></div>
                <div className={styles.loadingHolder_wrapper_ball}></div>
            </div>
            <p className={styles.loadingText}>{props.text}</p>
        </div>
    )
}

LoadingDots.propTypes = {
    text: PropTypes.string,
}

export default LoadingDots
